
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin/ai",
      function () {
        return require("private-next-pages/signin/ai/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signin/ai"])
      });
    }
  